import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import './index.scss';
import { scrollTop } from 'utils';
import modifyImage from 'assets/modify.svg';
import modifyHoverImage from 'assets/modify-hover.svg';

const ModifyButton = ({ onClick = () => {}, link }) => {
  const [ isHover, setIsHover ] = useState(false);
 
  const onClickFunc = (e) => {
    scrollTop();
    onClick(e);
  };

  return (
    <Link
      to={link}
      className="ModifyButton"
      onClick={onClickFunc}
      onMouseOver={() => setIsHover(true)}
      onFocus={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
      onBlur={() => setIsHover(false)}
    >
      <img className={clsx('A-MB-icon', { disp: isHover })} src={modifyHoverImage} alt="modify" />
      <img className={clsx('A-MB-icon', { disp: !isHover })} src={modifyImage} alt="modify" />
    </Link>
  );
};

export default ModifyButton;